import React, { createContext, useContext, useEffect, useState } from "react";
import client, { getToken, setToken, clearToken } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin
  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    client.get("/auth/me").then((r) => setUser(r.data)).catch(() => { clearToken(); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const r = await client.post("/auth/login", { email, password });
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { clearToken(); setUser(false); };
  const changePassword = async (current_password, new_password) => {
    const r = await client.post("/admin/change-password", { current_password, new_password });
    return r.data;
  };

  return <AuthCtx.Provider value={{ user, login, logout, changePassword }}>{children}</AuthCtx.Provider>;
}
